<template>
  <div class="home">
    <mynav1_en :data='nvdata'></mynav1_en>
    <div id="ndp1">
      <div>MEDIA LIBRARY</div>
      <div>Here you can learn more about our products, application scenarios and business models, there is always a product for you.</div>
    </div>
    <div id="ndp2" v-html="pgdata.html"></div>
    <myfooter_en :data='ftdata'></myfooter_en>
  </div>
</template>
<style>
  #ndp1 {
    height: 3.64rem;
    background-image: url('../assets/pic/head2.png');
    background-size: 100% 100%;
    padding-left: 4.26rem;
    padding-top: 1.13rem;
    box-sizing: border-box;
  }
  #ndp1 div:nth-child(1) {
    font-size: .48rem;
    font-weight: 800;
    color: #303030;
  }
  #ndp1 div:nth-child(2) {
    width: 6.5rem;
    white-space: normal;
    font-size: .14rem;
    font-weight: 500;
    color: #393939;
    margin-top: .31rem;
  }
  #ndp2 {
    text-align: center;
    padding: .67rem 3.44rem .68rem 3.44rem;
  }
</style>
<script>
// @ is an alias to /src
import mynav1_en from '@/components/mynav1_en'
import myfooter_en from '@/components/footer_en'


export default {
  components: {
    mynav1_en,myfooter_en
  },
  data () {
    return {
      pgdata: {},
      nindex: -1,
      ovscroll: false,
      scrdist: 0,
      ftdata: {
        type: 'medialib',
        lcallback: (stype) => {
          if (stype) {
            // this.setHead(stype)
          }
        }
      },
      nvdata: {
        sindex: 3,
        type: 'medialib',
        lcallback: (stype,sstype) => {
          if (stype||sstype) {
            // this.setHead(stype?stype:sstype)
          }
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {
    backToTop () {
      window.scrollTo(0,0)
    },
    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
    init () {
      // var stype = this.$route.query.sstype?this.$route.query.sstype:'brochure'
      // this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.nindex = this.$route.query.index
    this.pgdata = require('../../public/news.json').data[this.nindex]
  }
}
</script>
